/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserMe } from './UserMe';
import {
    UserMeFromJSON,
    UserMeFromJSONTyped,
    UserMeToJSON,
} from './UserMe';

/**
 * 
 * @export
 * @interface GetCurrentUser200ResponseAllOfData
 */
export interface GetCurrentUser200ResponseAllOfData {
    /**
     * 
     * @type {UserMe}
     * @memberof GetCurrentUser200ResponseAllOfData
     */
    user: UserMe;
}

/**
 * Check if a given object implements the GetCurrentUser200ResponseAllOfData interface.
 */
export function instanceOfGetCurrentUser200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user" in value;

    return isInstance;
}

export function GetCurrentUser200ResponseAllOfDataFromJSON(json: any): GetCurrentUser200ResponseAllOfData {
    return GetCurrentUser200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetCurrentUser200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentUser200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': UserMeFromJSON(json['user']),
    };
}

export function GetCurrentUser200ResponseAllOfDataToJSON(value?: GetCurrentUser200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': UserMeToJSON(value.user),
    };
}

